webpackJsonp([35783957827783],{

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/home-mobile.0999e30a.gif";

/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/home.0fe115d8.gif";

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  max-width: 1000px;\n  content: url(', ');\n\n  @media (min-width: 576px) {\n    content: url(', ');\n  }\n'], ['\n  width: 100%;\n  max-width: 1000px;\n  content: url(', ');\n\n  @media (min-width: 576px) {\n    content: url(', ');\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(77);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	__webpack_require__(412);
	
	var _Layout = __webpack_require__(23);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	var _home = __webpack_require__(559);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _homeMobile = __webpack_require__(558);
	
	var _homeMobile2 = _interopRequireDefault(_homeMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Animation = _styledComponents2.default.img(_templateObject, _homeMobile2.default, _home2.default);
	
	var IndexPage = function IndexPage(_ref) {
	  var locale = _ref.pathContext.locale;
	  return _react2.default.createElement(
	    _Layout2.default,
	    { locale: locale },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(Animation, null)
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ }),

/***/ 412:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-a3126981ac4cbee63e97.js